import React from 'react';
import { createGlobalStyle } from 'styled-components';
import 'css-doodle';
import Doodle from './doodle'
// Global styles
const GlobalStyle = createGlobalStyle`
  html, body { 
    width: 100%;
    height: 100%; 
    margin: 0;
    display: flex; 
    align-items: center; 
    justify-content: center;
    background: radial-gradient(#459dc1, #070729);
    overflow: hidden;
  } 
`;

const DoodleComponent: React.FC = () => {

  return (
    <>
      <GlobalStyle />
      <Doodle />
    </>
  );
};

export default DoodleComponent;
